import React from "react";
import { CobrancaContaDetailsItem } from "core/features/cobranca/typings";
import { View, Text } from "@react-pdf/renderer";
import { commonRelatorioPdfStyles } from "components/Relatorio/styles";
import { PDFTable } from "ui/components/PDF";
import TotalRow from "../TotalRow";
import PDFTag from "ui/components/PDF/components/Tag";
import useRelatorioCobrancasPdfColumns from "./hooks/useRelatorioCobrancasPdfColumns";
import moment from "moment";
import colors from "core/resources/theme/colors";

interface PDFRelatorioCobrancasItemTableProps {
  item: CobrancaContaDetailsItem;
}

function ItemTable({ item }: PDFRelatorioCobrancasItemTableProps) {
  const columns = useRelatorioCobrancasPdfColumns();

  return (
    <View>
      <View style={commonRelatorioPdfStyles.itemTableTitleRow}>
        <Text style={commonRelatorioPdfStyles.itemTableTitle}>
          {item.descricao}
        </Text>
        <View style={{ marginLeft: 4 }}>
          <PDFTag
            text={`Vencimento ${moment(item.dataVencimento).format(
              "DD/MM/YYYY"
            )}`}
          />
        </View>

        {item.diasEmAtraso ? (
          <View style={{ marginLeft: 4 }}>
            <PDFTag
              text={`${item.diasEmAtraso} ${
                item.diasEmAtraso === 1 ? "dia" : "dias"
              } em atraso`}
              style={{
                variant: "solid",
                color: colors.red500,
              }}
            />
          </View>
        ) : null}
      </View>
      <PDFTable
        data={item.composicoes}
        columns={columns}
        tableHeaderVariant="rowLike"
      />
      <View style={commonRelatorioPdfStyles.itemTableSummary}>
        <TotalRow {...item} />
      </View>
    </View>
  );
}

export default ItemTable;
